<template>
  <div class="content-wrapper">
    <div class="card card-with-shadow border-0">
      <div class="card-header p-primary bg-transparent">
        <h5 class="card-title m-0">{{ $t("assign_form") }}</h5>
      </div>
      <div class="card-body">
        <!-- <app-overlay-loader v-if="preloader" /> -->
        <form
          ref="form"
          :data-url="addurl"
          class="mb-sm-0"
          id="task_form"
          :class="{ 'loading-opacity': preloader }"
        >
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("forms") }}</label>
                <!-- <app-input
                  type="select"
                  :placeholder="$t('forms')"
                  :list="forms"
                  v-model="inputs.form_id"
                /> -->
                <app-input
                  type="multi-select"
                  :placeholder="$t('forms')"
                  :list="forms"
                  v-model="inputs.form_id"
                  :required="true"
                />
                <p v-if="refreshShow == false" class="font-italic text-muted">
                  {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                </p>
                <p v-if="refreshShow == true" class="font-italic text-muted">
                  <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("title") }}</label>
                <app-input type="text" v-model="inputs.title"
                :required="true" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("description") }}</label>
                <app-input
                  type="textarea"
                  id="textarea-id"
                  :label="$t('message_placeholder')"
                  v-model="inputs.description"
                  :required="true"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("start_date") }}</label>
                <app-input
                  type="date"
                  :required="true"
                  v-model="inputs.start_date"
                  :placeholder="$t('select_valid_date')"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("due_date") }}</label>
                <app-input
                  type="date"
                  v-model="inputs.due_date"
                  :required="true"
                  :placeholder="$t('select_valid_date')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("priority") }}</label>
                <app-input
                  type="radio"
                  :list="list"
                  v-model="inputs.priority"
                  :required="true"
                />
              </div>
            </div>
          </div>
          <div class="mt-5 action-buttons">
            <app-load-more
              :preloader="preloader"
              :label="$t('submit')"
              type="submit"
              class-name="btn btn-primary"
              @submit="submit"
            />
            <!-- <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="formAssign"
            >
              {{ $t("submit") }}
            </button> -->
            <button
              type="submit"
              class="btn btn-secondary"
              @click.prevent="clear"
            >
              {{ $t("clear") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BUYER_CERTIFICATE_FORMS,
  BUYER_CERTIFICATE_FORM_ASSIGN,
  COMPANY_GET_DETAILS,
} from "../../../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../../Helpers/AppLibrary";
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";

export default {
  name: "CompanyProfileView",
  extends: AppLibrary,
  mixins: [FormMixin],

  data() {
    return {
      refreshShow: false,
      preloader: false,
      addurl: BUYER_CERTIFICATE_FORM_ASSIGN,
      company: {},
      inputs: {},
      forms: {},
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
    };
  },
  methods: {
     beforeSubmit() {
        // this.scrollToTop(true);
        this.preloader = true;
            },
    submit() {
      // this.preloader = true;
      this.inputs.type = "form";
      this.inputs.userId = this.$attrs['props'].user_id;

      // axiosPost(BUYER_CERTIFICATE_FORM_ASSIGN, this.inputs)
      //   .then((res) => {
      //     
      //     this.$toastr.s(res.data);
      //   })
      //   .catch((error) => {
      //     
      //   })
      //   .finally(() => {
      //     this.inputs = [];
      //   });
        this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data);

      this.inputs = {};
      this.preloader = false;
    },

    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nSplit = split[7].split("?");
    let id = this.$attrs['props'].company_id;
    this.inputs.company_id = id;
    this.inputs.certificate_id = this.$attrs['props'].certificate_id;
    this.getForms();
  },
};
</script>
